import { watchImmediate } from "@vueuse/core";
import { useHost } from "vue";
import { useBreakpoints } from "#ce/composables/useBreakpoints";

/**
 * Sets up the col logic (breakpoint class toggles, etc.)
 */
export function useCol() {
  const host = useHost();
  const { isSmScreen, isMdScreen, isLgScreen } = useBreakpoints();

  watchImmediate([isSmScreen, isMdScreen, isLgScreen], () => {
    host.classList.toggle("--is-sm-screen", isSmScreen.value);
    host.classList.toggle("--is-md-screen", isMdScreen.value);
    host.classList.toggle("--is-lg-screen", isLgScreen.value);
  });
}
